var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyFormIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2992 4.5H11.3992C11.0128 4.5 10.6992 4.79185 10.6992 5.15V16.85C10.6992 17.2094 11.0128 17.5 11.3992 17.5H16.2992C16.6856 17.5 16.9992 17.2094 16.9992 16.85V5.15C16.9992 4.7912 16.6856 4.5 16.2992 4.5ZM15.5992 16.2H14.8992V14.9H12.7992V16.2H12.0992V5.8H15.5992V16.2Z",
    fill: "#959595"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 5.8H7.2V4.5H5.8V5.8H3.7C3.3136 5.8 3 6.09185 3 6.45V16.85C3 17.2094 3.3136 17.5 3.7 17.5H8.6C8.9864 17.5 9.3 17.2094 9.3 16.85V6.45C9.3 6.0912 8.9864 5.8 8.6 5.8ZM7.9 16.2H7.2V14.9H5.1V16.2H4.4V7.1H7.9V16.2Z",
    fill: "#959595"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9008 7.10156H12.8008V8.40156H14.9008V7.10156Z",
    fill: "#959595"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19961 8.39844H5.09961V9.69844H7.19961V8.39844Z",
    fill: "#959595"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19961 11H5.09961V12.3H7.19961V11Z",
    fill: "#959595"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9008 9.69922H12.8008V10.9992H14.9008V9.69922Z",
    fill: "#959595"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9008 12.3008H12.8008V13.6008H14.9008V12.3008Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyFormIcon);
export default __webpack_public_path__ + "static/media/CompanyFormIcon.b8ed8be6b3e7cdc0419784af09be6894.svg";
export { ForwardRef as ReactComponent };